module.exports = __webpack_public_path__ + "img/undraw_hooked_c757.6db65e90.svg";